import { Link } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { useAppLanguage } from "@/hooks/use-app-language"
import {
  getImpressumHref,
  getPrivacyPolicyHref,
} from "@/lib/app-language"
import { cn } from "@/lib/utils"

const SHOP_BRAND_NAME = "myLangguth Shop"

const linkClass =
  "font-medium text-primary underline-offset-4 hover:underline"

export function LegalFooter({ className }: { className?: string }) {
  const { t } = useTranslation()
  const language = useAppLanguage()

  return (
    <footer
      className={cn(
        "shrink-0 border-t border-border/80 bg-background pb-[max(0.25rem,env(safe-area-inset-bottom))]",
        className,
      )}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-x-3 px-3 py-1.5 text-xs text-muted-foreground sm:justify-between sm:gap-4 sm:px-6 sm:py-3 sm:text-sm">
        <p className="hidden shrink-0 sm:block">{SHOP_BRAND_NAME}</p>
        <nav className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 sm:gap-x-4">
          <a
            href={getImpressumHref(language)}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClass}
          >
            {t("legal.impressum")}
          </a>
          <a
            href={getPrivacyPolicyHref(language)}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClass}
          >
            {t("legal.privacy")}
          </a>
          <Link to="/legal/licenses" className={linkClass}>
            {t("legal.openSourceLicenses")}
          </Link>
        </nav>
      </div>
    </footer>
  )
}
